import classNames from 'classnames';
import Icon, {IconSize} from '@/components/Icon';
import DropMenu, {DropMenuTrigger, DropMenuSize} from '@/components/DropMenu';
import UserInfoTooltip from '@/components/UserInfoTooltip';
import styles from './index.module.scss';
import {useHistory, useParams, useRouteMatch} from 'react-router-dom';
import routers, {buildPath} from '@/config/routers';
import Avatar, {AvatarSize} from '@/components/Avatar';
import UserListMore from '@/icons/UserListMore';

// LikeSvg
interface LikeProps {
    // docGuid: string;
    // repository: Repository;
    className?: string;
    userList: any[] | null;
    isLikeFrom?: boolean;
}

export default function Like(props: LikeProps) {
    const history = useHistory();

    const {className, userList, isLikeFrom} = props;
    const handleClickAvatar = (item: any) => () => {
        if (isLikeFrom) {
            return;
        }
        history.push(buildPath(routers.PersonalHome.path, {
            userName: item.name,
        }));
    };
    return (
        <div className={classNames(
            styles.likeWrap,
            className
        )}
        >
            {/* 点赞列表 */}
            <div className={
                styles.avatarWrap}
            >
                {/* 头像列表，只展示前七个 */}
                <div className={styles.avatarList}>
                    {
                        userList &&
                        userList.slice(0, 8).map(item => {
                            return (
                                <div className={styles.avatarItem} key={item.value}>
                                    <UserInfoTooltip
                                        userGuid={item.value}
                                        onlyAvatar
                                        // withNickNameInTooltip
                                        ignoreAnchor
                                    >
                                        <div onClick={handleClickAvatar(item)}>
                                            <Avatar
                                                className={styles.avatarItemTip}
                                                userGuid={item.value}
                                                size={AvatarSize.SM}
                                            />
                                        </div>
                                    </UserInfoTooltip>
                                </div>
                            );
                        })
                    }
                    {/* 查看更多列表 */}
                    {
                        (userList && userList.length > 8) &&
                        <DropMenu
                            className={styles.menuStyle}
                            triggerType={DropMenuTrigger.Hover}
                            size={DropMenuSize.LG}
                            options={userList || []}
                            withArrow
                            placement={'bottom'}
                        >
                            <div className={styles.moreIcon}>
                                <UserListMore />
                            </div>
                        </DropMenu>
                    }
                </div>
            </div>
        </div>
    );
}
